<mat-expansion-panel hideToggle class="category-filter box-shadow"
                     *ngIf="subCategories.length && subCategories[0].isVisible"
                     [expanded]="true" (closed)="categoryExpanded = false"
                     (opened)="categoryExpanded = true">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'globalUi.filter.categoryLevel2' | translate }}</mat-panel-title>
    <mat-panel-description fxFlex="">
      <span fxFlex=""></span>
      <img alt=""  src="assets/icons/add-24px-2.svg" *ngIf="!categoryExpanded else showLess">
      <ng-template #showLess>
        <img alt="" src="../../../../assets/icons/close-icon.svg" >
      </ng-template>
    </mat-panel-description>

  </mat-expansion-panel-header>

    <ng-container *ngFor="let category of subCategories" class="cat-content">
      <input title="input"
        class="input"
        type="radio"
        name="child-category"
        [id]="category.id"
        [checked]="category.id === this.selectedSubCategoryId "
        (change)="selectCategory(category)"
      />

      <label class="label1" [for]="category.id"> {{ category.label }} </label>
    </ng-container>

</mat-expansion-panel>

<mat-expansion-panel hideToggle class="category-filter box-shadow"
                     *ngIf="subSubCategories.length &&checked()"
                     [expanded]="true" (closed)="categoryExpanded = false"
                     (opened)="categoryExpanded = true">
  <mat-expansion-panel-header>
    <mat-panel-title>{{ 'globalUi.filter.categoryLevel3' | translate }}</mat-panel-title>
    <mat-panel-description fxFlex="">
      <span fxFlex=""></span>
      <img alt=""  src="assets/icons/add-24px-2.svg" *ngIf="!categoryExpanded else showLess">
      <ng-template #showLess>
        <img alt="" src="../../../../assets/icons/close-icon.svg" >
      </ng-template>
    </mat-panel-description>

  </mat-expansion-panel-header>

  <div class="cat-content">
    <ng-container *ngFor="let category of subSubCategories">
      <input title="input"
        class="input"
        type="checkbox"
        name="child-category"
        [id]="category?.id"
        [checked]="selectedCateogries?.includes(category.id) "
        (change)="selectCategory1(category.id)"/>
      <label class="label2" [for]="category.id"> {{ category.label }} </label>
    </ng-container>

  </div>
</mat-expansion-panel>
